// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Program__Wrapper_1oCCp","Title":"Program__Title_3hIt1","Image":"Program__Image_270dH","Link":"Program__Link_2uFTa"};